import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-stat-panel',
  styleUrls: ['./stat-panel.component.css'],
  templateUrl: './stat-panel.component.html',
})
export class StatPanelComponent implements OnInit {
  @Input() icon: string;
  showTractorIcon: boolean;
  iconConfiguration: string[];
  isValueBoolean: boolean;
  @Input() label: string;
  label1: string;
  label2: string;
  @Input() value: boolean | number | string;

  private allowedIcons = [
    'alarm-snooze',
    'arrows-alt-h',
    'car-bump',
    'car-crash',
    'clipboard-check',
    'clock',
    'eye',
    'map-alert-alt',
    'map-marked-alt',
    'play-circle',
    'reply-all',
    'road',
    'search',
    'steering-wheel',
    'share-alt',
    'tachometer-alt-fastest',
    'tachometer-alt-slowest',
    'tasks',
    'users',
    'file-check',
    'traffic-cone',
    'calendar-exclamation',
    'truck',
  ];

  constructor() {}

  getTextWidth(txt: string, font: string) {
    const element = document.createElement('canvas');
    const context = element.getContext('2d');
    context.font = font;
    return context.measureText(txt).width;
  }

  ngOnInit() {
    this.showTractorIcon = false;
    if (this.allowedIcons.includes(this.icon)) {
      this.iconConfiguration = ['fal', this.icon];
      if (this.icon === 'truck') {
        this.showTractorIcon = true;
      }
    } else if (this.icon !== '') {
      console.warn(
        `StatPanelComponent: Icon '${this.icon}' is not part of the allowed icons.
         Allowed icons are: ${this.allowedIcons.toString()}`
      );
    }

    if (this.label && this.label.length > 0) {
      const words = this.label.split(' ');
      const half = words.length / 2 + 1;
      if (words.length === 2) {
        const width = this.getTextWidth(this.label, '10px Open Sans');
        if (width > 72) {
          this.label1 = words[0];
          this.label2 = words[1];
        } else {
          this.label1 = this.label;
        }
      } else if (half > 1) {
        this.label1 = words.slice(0, half).join(' ');
        this.label2 = words.slice(half, words.length).join(' ');
      } else {
        this.label1 = this.label;
      }
    }

    this.isValueBoolean = this.value === true || this.value === false;
  }
}
